import React from "react";
import EmptyExchangeIcons from "../../Icons/EmptyExchangeIcons";
import CommonButton from "../../Buttons/CommonButton";
import AddAccountModal from "../../Modals/AddAccount/AddAccountModal";

const EmptyExchange = ({ description }) => {
  return (
    <div className="md:max-w-[400px] mt-6">
      <div className="flex flex-col items-center justify-center space-y-10">
        <EmptyExchangeIcons />
        <h2 className="font-normal text-center text-text-secondary">
          {description}
        </h2>
        <AddAccountModal>
          <CommonButton>Add Currency Account</CommonButton>
        </AddAccountModal>
      </div>
    </div>
  );
};

export default EmptyExchange;
